import { Handle, Position } from 'reactflow'
import classes from './nodeStyles.module.scss'

export const YOUR_APP_NODE_WIDTH = 175
export const YOUR_APP_NODE_HEIGHT = 113

const nodeStyle = {
  width: YOUR_APP_NODE_WIDTH,
  height: YOUR_APP_NODE_HEIGHT,
}

export function YourAppNode() {
  return (
    <div style={nodeStyle} className={classes.app}>
      <div className={classes.app_header}>
        <span>
          <i></i>
          <i></i>
          <i></i>
        </span>
        Your product
      </div>
      <div className={classes.app_body}>
        <div>
          <span></span>
          <span></span>
        </div>
        <div>
          <span></span>
        </div>
      </div>
      <Handle type='target' position={Position.Right} className='opacity-0' />
    </div>
  )
}
